import { render, staticRenderFns } from "./EmployeeFormCardContainer.vue?vue&type=template&id=4898e09a&"
import script from "./EmployeeFormCardContainer.vue?vue&type=script&lang=js&"
export * from "./EmployeeFormCardContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports